import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ParentMessageType } from 'src/app/common/models/ParentMessage';
import { RootMember } from 'src/app/common/models/RootMember';
import { ApiBaseService } from 'src/app/services/api-base.service';
import { NestedPopupService } from 'src/app/services/UI/nested-popup.service';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { IndividualApiService } from '../../../services/API/individual-api.service';
import { LinkRequest } from 'src/app/common/models/LinkRequest';

@Injectable({
  providedIn: 'root'
})
export class MembereditorService {

  memberEditorStatus: Subject<boolean> = new Subject();
  subscriptionRootMemberId: any;
  rootMemberId: number;
  rootMember: Subject<RootMember> = new Subject();

  constructor(private apiBaseService: ApiBaseService,
    private individualApiService: IndividualApiService,
    private parentCommunicatorService: ParentCommunicatorService) {
      this.subscriptionRootMemberId = this.parentCommunicatorService.receive(
      ParentMessageType.RootMemberChanged,
      (rootMember) => {
        if (rootMember) {
          if (this.rootMemberId != rootMember.Id) {
            this.rootMemberId = rootMember.Id;
          }
          this.rootMember.next(rootMember);
        }
      }
    );
  }


  showMember(visibility: boolean) {
    this.memberEditorStatus.next(visibility);
  }

  onRootMemberChanged(): Observable<RootMember> {
    return this.rootMember;
  }

  onVisibilityChanged(): Observable<boolean> {
    return this.memberEditorStatus;
  }

  getMember<T>(): Observable<T> {
    if (this.rootMemberId === undefined)
      return null;
    return this.individualApiService.getMember(this.rootMemberId);
  }

  updateMember<T>(data: any): Observable<T> {
    return this.apiBaseService.update('/api/individual/' + this.rootMemberId, null, data);
  }

  getPlaces<T>(): Observable<T> {
    return this.apiBaseService.get('/api/place', null, null);
  }

  getReferencedMultimedias<T>(): Observable<T> {
    return this.individualApiService.getReferencedMultimedias(this.rootMemberId);
  }

  updateMultimediaLink<T>(linkRequest: LinkRequest, memberId: number): Observable<T> {
    return this.individualApiService.updateMultimediaLink(linkRequest, memberId);
  }

  unlinkMultimediaLink(mediaId: number, memberId: number): Observable<any> {
    return this.individualApiService.unlinkMultimediaLink(mediaId, memberId);
  }
}
